import { useEffect } from 'react';
import { connect } from 'react-redux';

import PropTypes from 'prop-types';

import NPSTableComponent from '../components/NPSTableComponent';

import { onModalClose } from '../../Modal/actions';
import {
  getNotificationPreferences,
  putNotificationPreferences,
} from '../actions';

const sortNotificationPreferences = (notificationPreferences) => {
  let sortedNotificationPreferences = [];

  const parentCategories = notificationPreferences.map(
    (element) => element.parent,
  );
  const uniqParentCategories = [...new Set(parentCategories)].filter(
    (element) => element !== null,
  );

  uniqParentCategories.forEach((category) => {
    const parentCategory = notificationPreferences.find(
      (element) => element.name === category,
    );
    const subParentCatagories = notificationPreferences.filter(
      (element) => element.parent === category,
    );
    const currentCategorySet = [parentCategory, ...subParentCatagories];
    sortedNotificationPreferences = [
      ...sortedNotificationPreferences,
      ...currentCategorySet,
    ];
  });

  notificationPreferences.forEach((element) => {
    const isExists =
      sortedNotificationPreferences.findIndex(
        (setting) => setting.name === element.name,
      ) !== -1;
    if (!isExists) {
      sortedNotificationPreferences.push(element);
    }
  });

  return sortedNotificationPreferences;
};

const NPSTableContainer = ({
  getNotificationPreferences,
  notificationPreferences,
  onModalClose,
  putNotificationPreferences,
}) => {
  useEffect(() => {
    getNotificationPreferences();
  }, []);

  const sortedNotificationPreferences = sortNotificationPreferences(
    notificationPreferences,
  );

  return (
    <NPSTableComponent
      notificationPreferences={sortedNotificationPreferences}
      onChange={putNotificationPreferences}
      onModalClose={onModalClose}
    />
  );
};

NPSTableContainer.propTypes = {
  getNotificationPreferences: PropTypes.func.isRequired,
  onModalClose: PropTypes.func.isRequired,
  putNotificationPreferences: PropTypes.func.isRequired,
  notificationPreferences: PropTypes.instanceOf(Array),
};

const mapStateToProps = (state) => {
  const { notificationPreferences } = state;
  return {
    notificationPreferences,
  };
};

const mapDispatchToProps = (dispatch) => ({
  getNotificationPreferences: () => getNotificationPreferences(dispatch),
  putNotificationPreferences: (data) =>
    putNotificationPreferences(dispatch, data),
  onModalClose: () => onModalClose(dispatch),
});

export default connect(mapStateToProps, mapDispatchToProps)(NPSTableContainer);
